import { storyblokEditable } from '@storyblok/react';
import { motion } from 'framer-motion';
import { FC } from 'react';

import Container from '@/components/elements/Container';
import Section from '@/components/elements/Section';
import StandardText, {
  StandardTextSize,
} from '@/components/elements/StandardText';

export interface LogosProps {
  blok: any;
  content: any;
}

const Logos: FC<LogosProps> = ({ blok }) => {
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.35,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 25 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 75,
        mass: 0.75,
        duration: 0.35,
      },
    },
  };

  return (
    <Section {...storyblokEditable(blok)}>
      <Container size={'wider'} className="grid grid-cols-1 gap-8 md:gap-16">
        <StandardText blok={blok} size={StandardTextSize.MD} />
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={container}
          className="grid grid-cols-2 place-content-evenly gap-12 md:grid-cols-5"
        >
          {blok.logos.map((l) => (
            <motion.img
              variants={item}
              key={l._uid}
              src={l.image.filename}
              alt=""
              className="justify-self-center align-middle md:w-[10vw]"
            />
          ))}
        </motion.div>
      </Container>
    </Section>
  );
};

export default Logos;
